import Vue from 'vue'
import * as servers from '@/services/user/servers'

export const namespaced = true

export const state = {
    servers: [{}]
}

export const mutations = {
    LOAD(state, servers) {
        state.servers = servers
    },
    LOAD_ONE(state, newServer) {
        Vue.set(
            state.servers,
            state.servers.findIndex(server => server._id === newServer._id),
            newServer
        )
    }
}

export const actions = {
    load({ commit }) {
        return servers.load().then(result => commit('LOAD', result.servers))
    },
    loadByID({ commit }, id) {
        return servers.loadByID(id).then(result => commit('LOAD_ONE', result.servers[0]))
    }
}

export const getters = {
    getByID: state => id => state.servers.find(server => server._id === id)
}